import { AccountIdentifier } from './AccountIdentifier.js';
export default AccountIdentifier;
//# sourceMappingURL=index.js.map